import api from '@/api/index.js'

const season_tickets_count_report = {
  state: {
    fileLoading: false,
    loading: false,
    reportData: null,
    error: null
  },


  mutations: {
    SPECIAL_SEASON_TICKETS_COUNT_REPORT_FILE_LOADING: (state, loading) => {
      state.fileLoading = loading;
    },
    SEASON_TICKETS_COUNT_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SEASON_TICKETS_COUNT_REPORT: (state, response) => {
      state.reportData = response;
      state.loading = false;
    },
    SEASON_TICKETS_COUNT_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetSpecialSeasonTicketsFile({commit}, query) {
      commit('SEASON_TICKETS_COUNT_REPORT_ERROR', null)
      commit('SPECIAL_SEASON_TICKETS_COUNT_REPORT_FILE_LOADING', true)
      return api.file(`reports/special-season-tickets?type=${query.type}`)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('SPECIAL_SEASON_TICKETS_COUNT_REPORT_FILE_LOADING', false)
        })
        .catch((error) => {
          commit('SEASON_TICKETS_COUNT_REPORT_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SPECIAL_SEASON_TICKETS_COUNT_REPORT_FILE_LOADING', false)
        })
    },

    GetSeasonTicketsCountReport({commit}) {
      commit('SEASON_TICKETS_COUNT_REPORT_ERROR', null)
      commit('SEASON_TICKETS_COUNT_REPORT', null)
      commit('SEASON_TICKETS_COUNT_REPORT_LOADING', true)
      return api.get(`reports/season-tickets-count`)
        .then((response) => {
          commit('SEASON_TICKETS_COUNT_REPORT', response)
        })
        .catch((error) => {
          commit('SEASON_TICKETS_COUNT_REPORT_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SEASON_TICKETS_COUNT_REPORT_LOADING', false)
        })
    }
  },
}

export default season_tickets_count_report
